<template>
	<div v-if="hasIntegrationsEnabled" class="flex flex-col items-start gap-8">
		<ButtonShareJira v-if="$store.isJiraIntegrationEnabled" :workspaceId="session.workspaceId" />
		<ButtonShareGithub v-if="$store.isGithubIntegrationEnabled" />
		<ButtonShareAzure v-if="$store.isAzureIntegrationEnabled" />
		<ButtonShareLinear v-if="$store.isLinearIntegrationEnabled" :session="session" />
		<ButtonShareTrello v-if="$store.isTrelloIntegrationEnabled" :session="session" />
		<ButtonShareEmail v-if="$store.isEmailManualIntegrationEnabled" :session="session" />
	</div>
	<ButtonShare v-else icon="mono/thunderbolt" data-test="integration-settings-link" @click="goToIntegrationSettings">
		Add an integration
		<span v-if="!$workspaceSubscription.isIntegrationAllowed" class="text-gray-400"> - Upgrade </span>
	</ButtonShare>
</template>

<script>
import {defineAsyncComponent} from 'vue'

import analytics from 'shared/utils/analytics'
import ButtonShareGithub from 'shared/components/ButtonShareGithub.vue'
import ButtonShareJira from 'shared/components/ButtonShareJira.vue'
import ButtonShareLinear from 'shared/components/ButtonShareLinear.vue'
import ButtonShareAzure from 'shared/components/ButtonShareAzure.vue'
import ButtonShare from 'shared/components/ButtonShare.vue'

export default {
	name: 'SessionDetailsIntegrationShareButtons',
	components: {
		ButtonShareGithub,
		ButtonShareJira,
		ButtonShareLinear,
		ButtonShareTrello: defineAsyncComponent(() => import('shared/components/ButtonShareTrello.vue')),
		ButtonShareEmail: defineAsyncComponent(() => import('shared/components/ButtonShareEmail.vue')),
		ButtonShareAzure,
		ButtonShare,
	},
	props: {
		session: Object,
	},
	emits: ['click'],
	computed: {
		hasIntegrationsEnabled() {
			return (
				this.$store.isGithubIntegrationEnabled ||
				this.$store.isJiraIntegrationEnabled ||
				this.$store.isLinearIntegrationEnabled ||
				this.$store.isTrelloIntegrationEnabled ||
				this.$store.isEmailManualIntegrationEnabled ||
				this.$store.isAzureIntegrationEnabled
			)
		},
	},
	methods: {
		goToIntegrationSettings() {
			analytics.track('Add an integration button clicked')
			this.$emit('click')
			this.$routerHelpers.navigateToWorkspaceSettings('integrations')
		},
	},
}
</script>
